import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SearchContextNavHolder = styled.div`
  &[data-position='top'] {
    margin-bottom: 32px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      margin-bottom: 40px;
    }
  }

  &[data-position='bottom'] {
    margin-top: 70px;
  }

  &[data-space-below] {
    margin-bottom: 48px;
  }

  &[data-hide-below-md] {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      display: none;
    }
  }
`;
